import { IndeterminateProgress } from "@/web/components/primitives/indeterminate-progress";
import { ActionCard } from "@/web/routes/_protected/smb/-dashboard/-ActionCard";
import { CardRulesEngine } from "@/web/routes/_protected/smb/-dashboard/-CardRulesEngine";
import type {
  SmbActionCoreProps,
  SmbActionDefinition,
} from "@/web/routes/_protected/smb/-dashboard/-types";

function LoadingUnderwritingAction({ onSkip }: SmbActionCoreProps) {
  return (
    <ActionCard category="budget">
      <ActionCard.Header>
        <ActionCard.Badge>Budget</ActionCard.Badge>
      </ActionCard.Header>
      <ActionCard.Main>
        <ActionCard.Title>Building your underwriting questionnaire</ActionCard.Title>
        <ActionCard.Description>
          We're reviewing your data to generate the next set of underwriting questions. Feel free to
          keep exploring the app in the meantime.
        </ActionCard.Description>
        <div className="mt-5 flex flex-col gap-3">
          <IndeterminateProgress
            className="bg-white/20"
            indicatorClassName="text-white"
            aria-label="Building underwriting questionnaire"
          />
          <p className="text-xs opacity-70">This card will update as soon as it's ready.</p>
        </div>
      </ActionCard.Main>
      <ActionCard.Footer>
        <ActionCard.SkipButton onSkip={onSkip} title="Got it" />
      </ActionCard.Footer>
    </ActionCard>
  );
}

export function createLoadingUnderwritingAction(props: { id?: string } = {}): SmbActionDefinition {
  const { id = "loading-underwriting" } = props;
  return {
    id,
    category: "budget",
    canSkip: true,
    render: (core) => <LoadingUnderwritingAction {...core} />,
  };
}

export const loadingUnderwritingRule = CardRulesEngine.singletonRule({
  id: "loading-underwriting",
  priority: 80,
  when: CardRulesEngine.and(
    CardRulesEngine.or(
      CardRulesEngine.hasConnection("accounting"),
      CardRulesEngine.hasConnection("leases"),
    ),
    CardRulesEngine.underwritingResultsPending,
  ),
  build: () => createLoadingUnderwritingAction(),
});
